import * as API from '../utils/API/API';
import { useQuery } from 'react-query';

const User = API.user();
const QUERY_KEY = 'kycWidgetLink';

export function useKycWidgetLink(onlyForNewUsers = false) {
  return useQuery([QUERY_KEY], () => User.getKycWidgetLink(onlyForNewUsers), {
    refetchOnMount: false,
    staleTime: Infinity,
  });
}
